export default function EventNews() {
    return <>
        <div className="py-2 bg-gray-800 text-center">
            <div className="max-w-7xl px-4 sm:px-6 lg:px-8 mx-auto">
                <p className="text-sm text-white">
                    Free delivery on orders over $50
                </p>
            </div>
        </div>
    </>
}